"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'Applications',
  path: '/applications/list',
  meta: {
    expanded: false,
    title: 'Aplicações',
    iconClass: 'icon-ic_agenda',
    requiresAuth: true
  },
  children: [{
    name: 'Estatísticas',
    path: '/applications/list',
    icon: 'icon-ic_agenda',
    meta: {
      title: 'Estatísticas',
      requiresAuth: true
    }
  }, {
    name: 'Estrutura',
    path: '/applications/structure',
    icon: 'icon-ic_location',
    meta: {
      title: 'Estrutura',
      requiresAuth: true
    }
  }, {
    name: 'Produtos',
    path: '/applications/product',
    icon: 'icon-ic_estoque',
    meta: {
      title: 'Produtos',
      requiresAuth: true
    }
  }, {
    name: 'Prescrição',
    path: '/applications/prescription',
    icon: 'icon-ic_pdf1',
    meta: {
      title: 'Prescrição',
      requiresAuth: true
    }
  }, {
    name: 'Aplicação',
    path: '/applications/application',
    icon: 'icon-ic_agenda',
    meta: {
      title: 'Aplicação',
      requiresAuth: true
    }
  }, {
    name: 'Equipamentos',
    path: '/applications/equipment',
    icon: 'icon-ic_estoque',
    meta: {
      title: 'Equipamentos',
      requiresAuth: true
    }
  }]
};